import React from 'react';
import s from './style.module.css';
import { connect } from 'react-redux';

import Datetimepicker from '../../components/datetimepicker';
import DatetimepickerHeader from '../../components/datetimepickerheader';
import { updateNextButton } from '../../actions/global-actions';

class Page1 extends React.Component {
  	componentWillMount() {
  		this.props.updateNextButton(false)
  	}

	render(props) {
		return (
			<div className={s.content}>
				<DatetimepickerHeader />
				<Datetimepicker />
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	const {
		timeslot
	} = state.page2;
	const {nextBtn} = state.global;
	return {timeslot, nextBtn};
}

export default connect(mapStateToProps, {updateNextButton})(Page1);